// alert-popup.component.ts
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { actionsOrder } from 'src/app/main/orders/models/order.model';
@Component({
  selector: 'app-alert-popup',
  templateUrl:'./eta-reminder.component.html',
  styleUrls: ['./eta-reminder.component.scss']
})
export class EtaReminderComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
 
    
 constructor(
   public dialogRef: MatDialogRef<EtaReminderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { fd_number: string,order_id:number }
  ) {
      super();
  }
  @Output() triggerOrderFunction = new EventEmitter<actionsOrder>(); // Define the emitter

  ngOnInit(): void {
  }

  

}
